import {
	FETCH_MAIN_LIST,
	FAIL_FETCH_MAIN_LIST,
	SET_MAIN_LIST_DATA,
	RESET_MAIN_LIST_STATE,
	SUCCESS_UPDATE_DATE,
	RESET_PROCESS_ERROR,
} from '../actions';

const initialState = {
	data:[],
	isFetching: false,
	error: undefined,
	isProcessError : false
};
export default function mainListSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
    switch (action.type) {
		case FETCH_MAIN_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_FETCH_MAIN_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			ret.data = [];
			return ret;
		case SET_MAIN_LIST_DATA:
			ret.data = action.payload.data;
			ret.isFetching = false;
			return ret;
		case RESET_MAIN_LIST_STATE:
			ret.data = [];
			return ret;
		case SUCCESS_UPDATE_DATE:
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		default:
			return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/main-list.js